import BestStory from './BestStory'

export default BestStory
